define('collections/distributor_products',['require','collections/base','models/distributor_product'],function (request) {
    var BaseCollection = require('collections/base');
    var Model = require("models/distributor_product");
    return BaseCollection.extend({
        model : Model,
        url:"distributor-products.json"
    });
});
